<template>
	<v-container fill-height>
		<img src="@/assets/innotix-logo.png" alt="InnoTix">
	</v-container>
</template>

<script>
export default {
	name: 'Home',
	data: () => ({
		loading: false,
		selection: 1,
		messages: [
			{
				from: 'You',
				message: `Sure, I'll see you later.`,
				time: '10:42am',
				color: 'deep-purple lighten-1',
			},
			{
				from: 'John Doe',
				message: 'Yeah, sure. Does 1:00pm work?',
				time: '10:37am',
				color: 'green',
			},
			{
				from: 'You',
				message: 'Did you still want to grab lunch today?',
				time: '9:47am',
				color: 'deep-purple lighten-1',
			},
		],
	}),
	methods: {
		reserve() {
			this.loading = true;

			setTimeout(() => (this.loading = false), 2000);
		},
	},
};
</script>
